<template>
  <Footer class="footer">
    <div class="footer-content">
      <div class="footer-logo">
        <img
          class="white"
          src="../../assets/header/logo.png"
          alt="خالد صقر لوجو"
        />
      </div>
      <div class="footer-links">
        <p>تواصل معنا عبر</p>
      </div>
      <div class="footer-social">
        <a href="https://www.facebook.com/khaledsaqr" target="_blank">
          <img src="../../assets/footer/facebookLogo.png" alt="facebook" />
        </a>
        <a href="https://www.instagram.com/khaledsaqr" target="_blank">
          <img src="../../assets/footer/instagramLogo.png" alt="instagram" />
        </a>
        <a href="https://www.linkedin.com/khaledsaqr" target="_blank">
          <img src="../../assets/footer/linkedinLogo.png" alt="linkedin" />
        </a>
        <a href="https://www.twitter.com/khaledsaqr" target="_blank">
          <img src="../../assets/footer/twitterLogo.png" alt="twitter" />
        </a>
        <a href="https://www.youtube.com/khaledsaqr" target="_blank">
          <img src="../../assets/footer/youtubeLogo.png" alt="youtube" />
        </a>
      </div>
    </div>
    <div class="footer-copy">
      <p>
        حقوق النشر © 2024 لشركة Easy Tech . كل الحقوق محفوظة.
        <img src="../../assets/footer/easyTechLogo.png" alt="easy tech" />
      </p>
    </div>
  </Footer>
</template>
<script>
export default {
  name: "FooterComponent",
};
</script>
<style scoped>
.footer .footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #2b4239;
  padding: 0.5rem 0;
}
.footer .footer-logo,
.footer .footer-social,
.footer .footer-links {
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer .footer-links {
  border-right: 1px solid #ffffff80;
  border-left: 1px solid #ffffff80;
}
.footer .footer-links p {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}
.footer .footer-social {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
.footer .footer-copy {
  background-color: #1d2c26;
}
.footer .footer-copy p {
  text-align: center;
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
}
/* Media Queries */
@media (max-width: 1200px) {
  .footer .footer-content {
    gap: 1rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    padding: 2rem 0;
  }
  .footer .footer-logo,
  .footer .footer-social,
  .footer .footer-links {
    width: 100%;
  }
  .footer .footer-links {
    border: none;
  }
  .footer .footer-copy p {
    flex-direction: column;
    padding: 1rem;
    font-size: 1rem;
  }
}
</style>
